import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { WizardHpModelFilterSimulateurComponent } from 'projects/hp-api/src/lib/simulateur/wizard-menu/wizard-hp-model-filter-simulateur-component';
import { AppBaseModule } from '../../app-entry/app.base.module';
import { WizardNavCloneDeleteComponent } from './wizard-nav-clone-delete.component';


@Component({
  selector: 'app-wizard-multi-expansion-menu',
  templateUrl: './wizard-multi-expansion-menu.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-multi-expansion-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardMultiExpansionMenuComponent extends WizardHpBaseComponent implements OnInit {
  @ViewChild('simulateurFilter', { static: false }) simulateurFilter: WizardHpModelFilterSimulateurComponent;
  @ViewChild('wizardNavCloneDelete', { static: false }) wizardNavCloneDelete: WizardNavCloneDeleteComponent;
  panelOpenState = false;
  @Input() asideTabletState: string = "in";
  @Input() multiMenuAnswerState: string = "in";
  @Input() vuId = false;
  @Input() target_area_selected = false;
  @Input() showProduct_visua_menu = false;  
  @Input() type_view :any;
  @Input() shareBtn = false;
  @Input() catalog_index = 0;
  @Input() menu_selected = 0;
  @Input() element_showed ;
  @Input()  warpable_index = 0;  
  @Input()   hasInOrOutView = false;
  @Input()  list_catalogs = [];   
  toggleSlide = [];
  layers = [1, 2, 3, 4, 5, 6];
  layeron = [];
  gamme_filter: any;
  modele_filter: any;
  checkFilterModele = [];
  modeleFilter_selected = [];
  collection_selected = [];
  collection_keywords = [];
  rootKey: any;
  panneaux = [];
  listCatalog:any;
  globalData:any;  
  rootKeywordWindow = "OUVERTURE";
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);
    this.gamme_filter = this.getHpService().getConfig().herculepro.gamme_parameters;
    this.modele_filter = this.getHpService().getConfig().herculepro.filter_parameters;

    this.panneaux = this.getHpService().getPanneaux();
    this.getHpService().getRootCategoryType();
    this.listCatalog = this.getHpService().getAllCataglog();
    this.globalData =  this.getHpService().getMultiGlobaldata();

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getHpService().emitDataChange();
       
  }
  getSimulteurFilter() {
    return this.simulateurFilter;
  }
  setRootkey(key: any) {
    this.rootKey = key;
  }

  fetchAnswersWithFilter(event, grpId: any, categoryId: any, elementId: any, variable, code_type, key, keywords, index_) {
    
    this.getHpService().clearOptionSelected();
    this.getHpService().setBooleanParam("loadCatalo",false);
    this.getSimulateur().setShowMultiproduct(false);
   
    this.multiMenuAnswerState = (this.getSimulateur().getcurrentQuestion().currentCode === categoryId && this.multiMenuAnswerState !== 'in') ? "in" : "out"
    this.getHpService().setMenuAnswerState(this.multiMenuAnswerState);
    //this.getSimulateur().toggleMenu('default');
     this.getHpService().emitDataChange(); 
     this.getChangeDetectorRef().detectChanges();
     this.getSimulateur().fetchAnswersProducts(grpId, categoryId, elementId, variable, code_type, key, index_);
   if (this.checkMenuModele(keywords) || this.getHpService().getConfig().herculepro.has_not_filter) {
      this.getSimulateur().fetchAnswersProducts(grpId, categoryId, elementId, variable, code_type, key, index_);
      this.getHpService().emitDataChange(); 
      this.getChangeDetectorRef().detectChanges();
      return;
    }
    this.getSimulateur().fetchAnswersProducts(grpId, categoryId, elementId, variable, code_type, key, index_);
    this.getHpService().emitDataChange();
          var clsName = '';
          if (event != null && event.target != null && event.target.className != ''
            && event.target.className.indexOf('mat-list-tag') > -1) {
            var isFilterModule = this.getHpService().getConfig().menu_expansionPanel;
            var filterIdCode = this.getHpService().getConfig().menu_expansionPanelCategoryIdCode;
            var currentCartCode = this.getHpService().getQuestionICode(grpId, categoryId);
            if (isFilterModule && filterIdCode != null && filterIdCode != '' && currentCartCode != null
              && currentCartCode == filterIdCode) {
              if (this.getSimulteurFilter() != null) {
                this.getSimulteurFilter().filterChange(event, null, {
                  grpId: grpId,
                  categoryId: categoryId,
                  elementId: elementId,
                  variable: variable,
                  code_type: code_type,
                  key: key
                }, null);
                this.getHpService().emitDataChange(); 
                this.getChangeDetectorRef().detectChanges();
      
              } else {
                this.getSimulateur().fetchAnswersProducts(grpId, categoryId, elementId, variable, code_type, key, index_);
                this.getHpService().emitDataChange(); 
                this.getChangeDetectorRef().detectChanges();
              }
      
            } else {
              this.getSimulateur().fetchAnswersProducts(grpId, categoryId, elementId, variable, code_type, key, index_);
              this.getHpService().emitDataChange(); 
              this.getChangeDetectorRef().detectChanges();
            }
          }
        
  


  }
  checkMenuModele(keywords: any) {
    var list = keywords.split(",");
    const className = (element) => element === "MODELE";
    return list.findIndex(className) < 0
  }

 menuClicked(menuKeyword:any,keywords: any) {
    var list = keywords.split(",");
    const className = (element) => element === menuKeyword;
    return list.findIndex(className) < 0
  }
  
getCatalogSelected()
{
  return this.listCatalog ;
}

getArrayProductIndex(){

  this.getChangeDetectorRef().detectChanges()
  this.getHpService().emitDataChange(); 

}
setCurrentCatalogIndex(){
  if(this.getHpService().getCurrentProductIndex() == 0){
  this.getSimulateur().setCurrentProductIndex(0);
  this.getSimulateur().setShowMultiproduct(true);
  this.getHpService().emitDataChange();
  this.getChangeDetectorRef().detectChanges();
  }
}

}
